var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 60,
    viewBox: "0 0 67 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 15H40V30H66.6667V15Z",
    fill: "#21A366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6666 30H13.3333V56.6667C13.3333 58.5083 14.8249 60 16.6666 60H63.3333C65.1749 60 66.6666 58.5083 66.6666 56.6667V30Z",
    fill: "#185C37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 30H40V45H66.6667V30Z",
    fill: "#107C42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 15H13.3333V30H39.9999V15Z",
    fill: "#3FA071"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3333 0H40V15H66.6667V3.33333C66.6667 1.49167 65.175 0 63.3333 0Z",
    fill: "#33C481"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 0H39.9999V15H13.3333V3.33333C13.3333 1.49167 14.8249 0 16.6666 0Z",
    fill: "#21A366"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M30.5316 11.666H13.3333V51.666H30.5316C33.9199 51.666 36.6666 48.9193 36.6666 45.531V17.801C36.6666 14.4127 33.9199 11.666 30.5316 11.666Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M30.3549 50.001H13.3333V12.2227H30.3549C33.2283 12.2227 35.5566 14.551 35.5566 17.4243V44.7993C35.5549 47.6727 33.2266 50.001 30.3549 50.001Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M30.1766 48.3323H13.3333V12.7773H30.1766C32.5333 12.7773 34.4433 14.6873 34.4433 17.044V44.0657C34.4449 46.4223 32.5333 48.3323 30.1766 48.3323Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30 46.6673H3.33333C1.49167 46.6673 0 45.1756 0 43.334V16.6673C0 14.8257 1.49167 13.334 3.33333 13.334H30C31.8417 13.334 33.3333 14.8257 33.3333 16.6673V43.334C33.3333 45.1756 31.8417 46.6673 30 46.6673Z",
    fill: "url(#paint0_linear_21174_11198)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67805 21.666H13.6547L16.8814 27.9227L20.2914 21.666H24.0064L18.8881 29.9993L24.1231 38.3327H20.2047L16.688 31.7827L13.1864 38.3327H9.20972L14.5314 29.9693L9.67805 21.666Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21174_11198",
    x1: 1.20833,
    y1: 14.5423,
    x2: 31.7583,
    y2: 45.0923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6731"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.34cd22f5aecabb9935b51a2c96393423.svg";
export { ForwardRef as ReactComponent };